/* eslint-disable import/prefer-default-export */
// 국세청 전송 결과
export const taxInvoiceNtsResultType = {
    NONE: 'NONE', // 없음
    SUCCESS: 'SUCCESS', // 성공
    ELECTRONIC_SIGNATURE_ERROR: 'ELECTRONIC_SIGNATURE_ERROR', // 전자서명 오류
    APPROVAL_NUMBER_ERROR: 'APPROVAL_NUMBER_ERROR', // 승인번호 오류
    ELECTRONIC_TAX_INVOICE_SCHEMA_ERROR: 'ELECTRONIC_TAX_INVOICE_SCHEMA_ERROR', // 전자세금계산서 스키마 오류
    SUPPLIER_BUSINESS_REGISTRATION_NUMBER_ERROR: 'SUPPLIER_BUSINESS_REGISTRATION_NUMBER_ERROR', // 공급자 사업자번호 오류
    RECIPIENT_BUSINESS_REGISTRATION_NUMBER_ERROR: 'RECIPIENT_BUSINESS_REGISTRATION_NUMBER_ERROR', // 공급받는자 사업자번호 오류
    TRUSTEE_BUSINESS_REGISTRATION_NUMBER_ERROR: 'TRUSTEE_BUSINESS_REGISTRATION_NUMBER_ERROR', // 수탁자 사업자번호 오류
    PUBLISH_DATE_ERROR: 'PUBLISH_DATE_ERROR', // 발행일시 오류
    WRITE_DATE_ERROR: 'WRITE_DATE_ERROR', // 작성일자 오류
    SUPPLY_TAX_AMOUNT_ERROR: 'SUPPLY_TAX_AMOUNT_ERROR', // 공급가액, 세액 오류
    CODE_TYPE_ERROR: 'CODE_TYPE_ERROR', // 코드 유형 오류
    CLOSED_BUSINESS_PUBLISH_ERROR: 'CLOSED_BUSINESS_PUBLISH_ERROR', // 폐업사업자 발행 오류
    NATIONAL_TAX_SERVICE_REGISTRATION_NUMBER_ERROR: 'NATIONAL_TAX_SERVICE_REGISTRATION_NUMBER_ERROR', // 국세청 등록번호 오류
    ORIGINAL_APPROVAL_NUMBER_ERROR: 'ORIGINAL_APPROVAL_NUMBER_ERROR', // 당초승인번호 오류
    OTHER_ERRORS: 'OTHER_ERRORS', // 기타오류
};
